var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBroadcastGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 9.33332C8.73646 9.33332 9.33341 8.73637 9.33341 7.99999C9.33341 7.26361 8.73646 6.66666 8.00008 6.66666C7.2637 6.66666 6.66675 7.26361 6.66675 7.99999C6.66675 8.73637 7.2637 9.33332 8.00008 9.33332Z",
    stroke: "#389C67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8266 5.17344C11.1985 5.54493 11.4936 5.98609 11.6949 6.47168C11.8962 6.95727 11.9998 7.47778 11.9998 8.00344C11.9998 8.5291 11.8962 9.04961 11.6949 9.5352C11.4936 10.0208 11.1985 10.4619 10.8266 10.8334M5.17329 10.8268C4.80139 10.4553 4.50635 10.0141 4.30505 9.52853C4.10376 9.04294 4.00015 8.52244 4.00015 7.99677C4.00015 7.47111 4.10376 6.9506 4.30505 6.46501C4.50635 5.97942 4.80139 5.53827 5.17329 5.16677M12.7133 3.28677C13.9631 4.53696 14.6652 6.23235 14.6652 8.00011C14.6652 9.76787 13.9631 11.4633 12.7133 12.7134M3.28663 12.7134C2.03682 11.4633 1.33472 9.76787 1.33472 8.00011C1.33472 6.23235 2.03682 4.53696 3.28663 3.28677",
    stroke: "#389C67",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastGreen);
export default __webpack_public_path__ + "static/media/broadcast-green.b1c3b0aea9a4a64f3936e0e856ac4b04.svg";
export { ForwardRef as ReactComponent };